module.exports = __webpack_public_path__ + "img/qrcode.996d668e.png";